import CPanelLogsGrid from './cPanelLog-grid';
import { pagesConfig } from '../../shared/pages-config';
import { useUserSettings } from '../../utils/use-user-settings';
import SimpleBreadcrumbsPage from '../../shared/simple-breadcrumbs-page';
import { ModuleList } from '../../shared/analytics/module-list';

export default function CpanelLogsPage() {
  const { administrationRoles, changeLogRoles, loggedInUser, viewType } =
    useUserSettings();

  return (
    <SimpleBreadcrumbsPage
      breadcrumbs={[
        { label: ModuleList.modules.reportCenter.name },
        { label: pagesConfig.cPanelLogs.name },
      ]}
      bookmarkKey={pagesConfig.cPanelLogs.value}
    >
      <CPanelLogsGrid
        key={viewType.cpanelLogsGridStates?.activeGridState || 'default'}
        loggedInUser={loggedInUser}
        administrationRoles={administrationRoles}
        changeLogRoles={changeLogRoles}
      />
    </SimpleBreadcrumbsPage>
  );
}
